import Webcam from "react-webcam";
import AWS from "aws-sdk";
import { detectPatientByFace, faceLogin } from "../../../api/apiHandler";
import Swal from "sweetalert2";
import "@tensorflow/tfjs";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { loginStoreData } from "../../patient/common/RedirectPathMange";

const videoConstraints = {
  width: 300,
  height: 200,
  facingMode: "user",
};

const FaceLogin = () => {
  const webcamRef = useRef(null);

  const capture = () => {
    const screenshot = webcamRef.current?.getScreenshot();
    if (!screenshot) {
      alert("Unable to capture image. Try again.");
      return;
    }
    convertToBuffer(screenshot);
  };

  const rekognition = new AWS.Rekognition({
    accessKeyId: process.env.REACT_APP_AWS_S3_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_S3_SECRET_KEY,
    region: process.env.REACT_APP_AWS_S3_REGION,
  });

  const searchFaceByImage = async (imageBuffer) => {
    const params = {
      CollectionId: "Face-collection",
      FaceMatchThreshold: 90,
      Image: { Bytes: imageBuffer },
      MaxFaces: 1,
    };

    try {
      const result = await rekognition.searchFacesByImage(params).promise();
      console.log(result, "dedecteded");

      if (result.FaceMatches && result.FaceMatches.length > 0) {
        return result.FaceMatches[0].Face;
      } else {
        Swal.fire({
          icon: "info",
          title: "face is not matching",
          toast: true,
          showConfirmButton: false,
          timer: 4000,
        });
      }

      return null;
    } catch (err) {
      console.error("Face detection failed:", err);
      alert("No face detected or something went wrong.");
      return null;
    }
  };

  let dedectFace = async (result) => {
    try {
      Swal.fire({
        title: "Please wait...",
        didOpen: () => {
          Swal.showLoading();
        },
      });
      let response = await faceLogin({
        awsFaceId: result.FaceId,
      });
      if (response) {
        response = JSON?.parse(response);
      }
      if (response.message === "Patient Not Found") {
        Swal.fire({
          icon: "error",
          title: "No face match found",
          text: response.message || "Something went wrong.",
        });
        console.log(response, "❌ No face match found.");
      } else {
        Swal.close();
        console.log(response, "FaceLoginrepon");
        loginStoreData(response?.data);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "No face match found",
        text: error.message || "Something went wrong.",
      });
    }
  };
  const convertToBuffer = async (image) => {
    const buffer = base64ToBuffer(image);
    const result = await searchFaceByImage(buffer);

    if (result?.FaceId) {
      console.log("✅ Face matched:", result);
      dedectFace(result);
    } else {
      console.log(result, "❌ No face match found.");
      alert("No face match found. This face is not enrolled.");
    }
  };

  function base64ToBuffer(base64String) {
    const base64Data = base64String?.split(";base64,")?.pop();
    return Uint8Array.from(atob(base64Data), (c) => c.charCodeAt(0));
  }

  return (
    <main className="">
      <div className="container ">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6 col-xl-6 col-xxl-5 col-12">
            <div className="login-sec">
              <div className="logo-size">
                <img
                  src={process.env.PUBLIC_URL + "/assets/images/logo--a.png"}
                  alt="logo"
                />
              </div>
              <div className=" mb-4">
                <p className="font_26 font_600 text-center ">Biometric Login</p>
              </div>
              <div className="text-center mb-5">
                <Link
                  to="/signup"
                  className="text-white px-4 d-inline-flex align-items-center justify-center btn rounded"
                  style={{ background: "#fc7c37", fontSize: 13 }}
                >
                  Not a member? Signup now
                </Link>
              </div>

              <div className="text-center mb-3">
                <Webcam
                  ref={webcamRef}
                  audio={false}
                  screenshotFormat="image/jpeg"
                  height={200}
                  width={300}
                  videoConstraints={videoConstraints}
                  className="  rounded mb-3"
                />
              </div>
              <button
                className="login-btn w-100 border-0 mb-4"
                onClick={capture}
              >
                Login with Face
              </button>
            </div>
          </div>
        </div>{" "}
      </div>
    </main>
  );
};

export default FaceLogin;
